import React, { useCallback, useEffect, useState } from 'react';
import styles from './StickyHeader.module.scss';
import Button from '../Button/Button';
import { useModalContext } from '../../common/Context/ModalContext';

export const StickyHeader: React.FC = () => {
  const { activeStickyHeader } = useModalContext();
  const [isVisible, setIsVisible] = useState(false);

  const listenToScroll = useCallback(() => {
    if (!activeStickyHeader || !activeStickyHeader.data) {
      setIsVisible(false);
      return;
    }
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

    if (activeStickyHeader.isVisible && winScroll > activeStickyHeader.data.isVisibleHeight) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [activeStickyHeader]);

  useEffect(() => {
    if (activeStickyHeader) {
      listenToScroll();
    }
  }, [activeStickyHeader, listenToScroll]);

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, [listenToScroll]);

  return (
    <section
      aria-label={activeStickyHeader?.data?.label || 'Banner'}
      className={`${styles.StickyPublishOuterContainer} ${!isVisible && styles.isHide}`}
    >
      <div className={styles.StickyPublishContainer}>
        <span>{activeStickyHeader?.data?.text}</span>
        <div className={styles.Buttons}>
          {activeStickyHeader?.data?.secondaryAction ? (
            <Button
              level="low"
              id={`sticky-header-${activeStickyHeader.data.secondaryAction.text}-button`}
              onClick={() => activeStickyHeader?.data?.secondaryAction?.callback()}
            >
              {activeStickyHeader.data.secondaryAction.text}
            </Button>
          ) : null}
          {activeStickyHeader?.data?.primaryAction ? (
            <Button
              id={`sticky-header-${activeStickyHeader.data.primaryAction.text}-button`}
              onClick={() => activeStickyHeader?.data?.primaryAction.callback()}
            >
              {activeStickyHeader.data.primaryAction.text}
            </Button>
          ) : null}
        </div>
      </div>
    </section>
  );
};
